var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('ul',{staticClass:"cardList"},_vm._l((_vm.listData),function(v,i){return _c('li',{key:i},[_c('p',{style:({
                color: _vm.colorObj[v.name] ?_vm.colorObj[v.name]: '#333',
            })},[_vm._v(" "+_vm._s(v.name)+" ")]),_c('h5',[_vm._v(_vm._s(v.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }